<template>
  <div class="message_handle">
    <van-form @submit="onSubmit" ref="van_field_1">

      <van-field
        v-model="message"
        rows="9"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入处理意见"
        show-word-limit
        
      />
      <div class="foot">
        <button type="submit">提交</button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { mapActions} from 'vuex'
import Vue from 'vue';
import { Notify, Field, Form } from 'vant';
Vue.use(Notify);
Vue.use(Field);
Vue.use(Form);

export default {
  name: "messageHandle",
  components: {},
  props: {
    
  },
  data() {
    return {
      message: ''
    };
  },
  computed: {
    id () {
      return this.$route.query.id
    },
  },
  watch: {},
  methods: {
    ...mapActions('investment', ['setInvestmentTitle','addPrMessageFealRecord']),
    onSubmit() {//审核
        if (!this.message) {
          this.$Toast({message: "请输入处理意见"});
          return
        }
      // this.$refs.van_field_1.validate().then(yes =>{
        this.addPrMessageFealRecord({
          id: this.id,
          content: this.message
        }).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.$router.go(-1)
        })
      // })
    }
  },
  created() {
    this.setInvestmentTitle('留言处理')
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.message_handle {
    height: 100vh;
    font-family: PingFangSC-Regular;
    padding: 12px 12px 108px;
    background: #FFFFFF;
    /deep/.van-field__error-message {
      display: none;
    }
    /deep/.van-field::after{
      content: none;
    }
    /deep/.van-field{
      background: #F5F5F5;
      border-radius: 3px;
    }
    /deep/.van-field__word-limit{
      color: #CCCCCC;
    }
    .foot{
      position: fixed;
      bottom: 0;
      left: 0;
      bottom: 0;
      padding: 13px 12px 47px;
      background: #FFFFFF;
      width: 100%;
      button{
        border: 0;
        background: #36B374;
        display: block;
        width: 100%;
        padding: 13px;
        line-height: 22px;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 3px;
      }
    }
}
</style>